/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quiet_Safe_Lion_LimpInputs */

const en_quiet_safe_lion_limp = /** @type {(inputs: Quiet_Safe_Lion_LimpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderate`)
};

const de_quiet_safe_lion_limp = /** @type {(inputs: Quiet_Safe_Lion_LimpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittel`)
};

/**
* | output |
* | --- |
* | "Moderate" |
*
* @param {Quiet_Safe_Lion_LimpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quiet_safe_lion_limp = /** @type {((inputs?: Quiet_Safe_Lion_LimpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quiet_Safe_Lion_LimpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quiet_safe_lion_limp(inputs)
	return de_quiet_safe_lion_limp(inputs)
});